<!-- Main container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openSideDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="create()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
        <ng-template elderToolbarContent="center">
          <elder-search-box
            dense
            class="flex-60 pt-xs"
            queryKey="query"
            [autoPanel]="false"
            [elderSearchContext]="data.filter"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>account_tree</mat-icon>
        </td>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">{{ plan.name }}</td>
      </ng-container>

      <!-- Operations Column -->
      <ng-container matColumnDef="operations">
        <th mat-header-cell *matHeaderCellDef style="width: 50%" mat-sort-header>
          {{ 'operations.title' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">
          <div class="layout-row gap-sm">
            @for (segment of plan.operations; track segment) {
              <mat-chip-set class="action">
                <mat-chip highlighted>{{ segment?.action }}</mat-chip>
              </mat-chip-set>
            }
          </div>
        </td>
      </ng-container>

      <!-- preparation Column -->
      <ng-container matColumnDef="preparation">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.preparation' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">
          <mat-icon>{{
            plan?.preparationSpec?.enabled ? 'check_box' : 'check_box_outline_blank'
          }}</mat-icon>
        </td>
      </ng-container>

      <!-- createdAt -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
          {{ 'context.createdAt' | translate }}
        </th>
        <td mat-cell *matCellDef="let plan">
          {{ plan.createdAt | date: 'short' }}
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
